

<p-confirmDialog />

<div class="plan-page-container">
  <div class="plan-page-header">
    <h3 class="m-0">Payment Tracking</h3>
    <p-button
      *ngIf="!readonly"
      label="Add"
      icon="pi pi-plus"
      (onClick)="showAddItemDialog()"
      severity="info"
      [rounded]="true" />
  </div>

  <div class="pt-summary" *ngIf="!loading && items.length > 0">
    <div class="pt-summary-item">
      <span class="pt-summary-label">Invoiced</span>
      <span class="pt-summary-value">{{ formatPercentage(invoicedPercentage) }}</span>
      <span class="pt-summary-hint">Invoiced + Paid</span>
    </div>
    <div class="pt-summary-item">
      <span class="pt-summary-label">Planned</span>
      <span class="pt-summary-value" [class.pt-unbalanced]="plannedIsUnbalanced">
        {{ formatPercentage(plannedPercentage) }}
      </span>
      <span class="pt-summary-hint">
        {{ plannedIsUnbalanced ? 'Milestones do not total 100%' : 'All milestones' }}
      </span>
    </div>
  </div>

  <p-table
    [scrollable]="true"
    scrollHeight="flex"
    [value]="filteredItems"
    [loading]="loading"
    [paginator]="filteredItems.length > 20"
    [rows]="20"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [tableStyle]="{ 'min-width': '100%' }"
    styleClass="p-datatable no-column-lines compact-striped-table table-scroll-both payment-tracking-table">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 100px; text-align: center;">
          Number
        </th>
        <th>Payment Milestone</th>
        <th style="width: 100px">%</th>
        <th class="col-status" pTooltip="Target/expected invoice date" tooltipPosition="top">Target Date</th>
        <th class="col-status" pTooltip="Date invoice was raised" tooltipPosition="top">Invoiced Date</th>
        <th class="col-status" pTooltip="Date payment is due" tooltipPosition="top">Payment Due</th>
        <th class="col-status" pTooltip="Date payment was received" tooltipPosition="top">Paid Date</th>
        <th style="width: 150px">Invoicing Status</th>
        <th style="width: 160px" pTooltip="Whether payment was settled on time, is still due, or is overdue" tooltipPosition="top">Payment Status</th>
        <th>Comments</th>
        <th *ngIf="!readonly" style="width: 100px">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td style="text-align: center;">
            {{ item.number }}
        </td>
        <td class="td-truncate" [pTooltip]="item.paymentMilestone || '-'" tooltipPosition="top">{{ item.paymentMilestone || '-' }}</td>
        <td>{{ formatPercentage(item.percentage) }}</td>
        <td [pTooltip]="item.targetDate ? 'Target: ' + formatDate(item.targetDate) : 'No target date'" tooltipPosition="top">{{ formatDate(item.targetDate) }}</td>
        <td [pTooltip]="item.invoicedDate ? 'Invoiced: ' + formatDate(item.invoicedDate) : 'Not invoiced yet'" tooltipPosition="top">{{ formatDate(item.invoicedDate) }}</td>
        <td [pTooltip]="item.paymentDueDate ? 'Due: ' + formatDate(item.paymentDueDate) : 'No due date set'" tooltipPosition="top">{{ formatDate(item.paymentDueDate) }}</td>
        <td [pTooltip]="item.paidDate ? 'Paid: ' + formatDate(item.paidDate) : 'Not paid yet'" tooltipPosition="top">{{ formatDate(item.paidDate) }}</td>
        <td>
          <p-tag
            [value]="item.invoicingStatus"
            [severity]="getStatusSeverity(item.invoicingStatus)" />
        </td>
        <td [pTooltip]="getPaymentStatusTooltip(item)" tooltipPosition="top">
          <p-tag
            *ngIf="item.paymentStatus && item.paymentStatus !== 'Not Applicable'; else noPaymentStatus"
            [value]="getPaymentStatusLabel(item)"
            [severity]="getPaymentStatusSeverity(item.paymentStatus)" />
          <ng-template #noPaymentStatus>-</ng-template>
        </td>
        <td class="td-truncate" [pTooltip]="item.comments || '-'" tooltipPosition="top">{{ item.comments || '-' }}</td>
        <td *ngIf="!readonly" class="table-cell-actions">
          <div class="table-actions-stack">
            <p-button icon="pi pi-trash" (onClick)="deleteItem(item)" [text]="true" severity="danger" size="small"
              pTooltip="Delete" tooltipPosition="top" />
            <p-button icon="pi pi-pencil" (onClick)="showEditItemDialog(item)" [text]="true" severity="info" size="small"
              pTooltip="Edit" tooltipPosition="top" />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td [attr.colspan]="readonly ? 10 : 11" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No payment tracking items found</p>
            <p class="empty-description" *ngIf="filterDate">For the selected date ({{ filterDate }})</p>
            <p class="empty-description" *ngIf="!filterDate && !readonly">Click "Add" to create a new payment tracking item</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Item Dialog -->
<p-dialog
  [visible]="displayItemDialog"
  (visibleChange)="onDialogVisibleChange($event)"
  [header]="isEditItemMode ? 'Edit Payment Tracking Item' : 'Add Payment Tracking Item'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="false"
  [closable]="true"
  [contentStyle]="{'overflow': 'visible'}"
  [baseZIndex]="10000"
  (onHide)="onDialogVisibleChange(false)">
  <div class="form-dialog-form form-dialog-compact" *ngIf="selectedItem">
    <div class="form-dialog-container">
      <div class="form-row two-columns">
        <div class="field">
          <label for="number">Number</label>
          <input pInputText id="number" [value]="selectedItem.number" readonly class="readonly-field" />
        </div>
        <div class="field">
          <label for="percentage">Percentage (%) <span class="required-star">*</span></label>
          <p-inputnumber id="percentage" [(ngModel)]="selectedItem.percentage" [min]="0" [max]="100"
            [maxFractionDigits]="2" placeholder="Enter percentage" [showButtons]="true" />
        </div>
      </div>
      <div class="form-row two-columns">
        <div class="field">
          <label for="invoicingStatus">Invoicing Status <span class="required-star">*</span></label>
          <p-select id="invoicingStatus" [(ngModel)]="selectedItem.invoicingStatus" [options]="statusOptions"
            optionLabel="label" optionValue="value" placeholder="Select status"
            panelStyleClass="filter-dropdown-panel" appendTo="body"
            [ngClass]="'status-' + getStatusSeverity(selectedItem.invoicingStatus || '')">
            <ng-template let-option pTemplate="item">
              <div class="dropdown-item-content">
                <span class="status-badge" [ngClass]="'status-' + getStatusSeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
            <ng-template let-option pTemplate="selectedItem">
              <div class="dropdown-selected-content">
                <span class="status-badge" [ngClass]="'status-' + getStatusSeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['targetDate'] && targetDateIsBlocking">
          <label for="targetDate">
            Target Date <span class="required-star" *ngIf="!isEditItemMode">*</span>
          </label>
          <p-datepicker id="targetDate" [(ngModel)]="targetDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true"
            (onSelect)="fieldTouched['targetDate'] = true" (onClose)="fieldTouched['targetDate'] = true" />
          <small class="field-error" *ngIf="fieldTouched['targetDate'] && targetDateIsBlocking">
            Target date is required
          </small>
          <!-- Edit of a legacy row: warn, but never block someone from changing a status. -->
          <small class="field-hint-warning" *ngIf="isEditItemMode && targetDateMissing">
            Without a target date this milestone will not appear in the Invoicing Summary View.
          </small>
        </div>
      </div>
      <div class="form-row two-columns">
        <div class="field">
          <label for="invoicedDate" pTooltip="Date invoice was raised" tooltipPosition="top">Invoiced Date</label>
          <p-datepicker id="invoicedDate" [(ngModel)]="invoicedDate" (ngModelChange)="syncDerivedDueDate()"
            [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
        <div class="field">
          <label for="paymentTermDays" pTooltip="Days allowed for payment after the invoice is released" tooltipPosition="top">Payment Term (Days)</label>
          <input type="number" id="paymentTermDays" class="p-inputtext"
            [(ngModel)]="selectedItem.paymentTermDays" (ngModelChange)="syncDerivedDueDate()"
            [placeholder]="projectPaymentTermDays ? ('Project default: ' + projectPaymentTermDays) : 'e.g. 30'"
            min="1" max="3650" step="1" />
          <small class="field-hint" *ngIf="projectPaymentTermDays; else noProjectTerm">
            Leave blank to use the project default of {{ projectPaymentTermDays }} days.
          </small>
          <ng-template #noProjectTerm>
            <small class="field-hint">No project default set — enter a term here to get a due date.</small>
          </ng-template>
        </div>
      </div>
      <div class="form-row two-columns">
        <div class="field">
          <label for="paymentDueDate" pTooltip="Auto-filled from Invoiced Date + Payment Term. Edit to record an agreed extension." tooltipPosition="top">Payment Due Date</label>
          <p-datepicker id="paymentDueDate" [(ngModel)]="paymentDueDate" (ngModelChange)="onPaymentDueDateEdited()"
            [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
          <small class="field-hint">Recalculates when you change the invoiced date or term. Pick a date here to fix it for an agreed extension; clear it to resume auto-calculation.</small>
        </div>
        <div class="field">
          <label for="paidDate" pTooltip="Date payment was received" tooltipPosition="top">Paid Date</label>
          <p-datepicker id="paidDate" [(ngModel)]="paidDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
      </div>
      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['paymentMilestone'] && !selectedItem.paymentMilestone.trim()">
          <label for="paymentMilestone">Payment Milestone <span class="required-star">*</span></label>
          <textarea pInputText id="paymentMilestone" [(ngModel)]="selectedItem.paymentMilestone" rows="3"
            placeholder="Enter payment milestone..." required class="p-inputtext" (blur)="fieldTouched['paymentMilestone'] = true"></textarea>
          <small class="field-error" *ngIf="fieldTouched['paymentMilestone'] && !selectedItem.paymentMilestone.trim()">Payment milestone is required</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="comments">Comments</label>
          <textarea pInputText id="comments" [(ngModel)]="selectedItem.comments" rows="3" placeholder="Enter comments..." class="p-inputtext"></textarea>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetItemForm()" [text]="true" severity="secondary" styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="displayItemDialog = false" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveItem()" severity="primary" [disabled]="!selectedItem || !selectedItem.paymentMilestone.trim() || targetDateIsBlocking" />
    </div>
  </ng-template>
</p-dialog>

